import React from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";
import { StyledMainBox } from "../../../components/commonComponents/StyledComponents/styled";
import { Close, Download } from "@mui/icons-material";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import ActionButton from "../../../components/commonComponents/Buttons/ActionButton";
// import {TextButton} from "../../../components/commonComponents/Buttons/ActionButton";
import { fetchClipUrl } from "../../../api_calls/clipRequests";
import { toast } from "react-toastify";
import { checkUserDetailsFromCookie } from "../../../api_calls/userManagement";

const PlayClip = ({ open, onClose, size, closeModal, clipInfo }) => {
  const [clipUrl, setClipUrl] = React.useState("");
  const userDetail = checkUserDetailsFromCookie();


  React.useEffect(() => {
    const rootCompanyId = userDetail.user_detail.root_company_id;
    /*
      update: 28 April 2025,
      clipInfo.clip_company_id replaced by rootCompanyId as asked by the backend.
    */
    fetchClipUrl(clipInfo.id, rootCompanyId).then((info) => {
      if (info.success === true) {
        setClipUrl(info.clip_file_url);
      } else {
        toast("Sorry, clip can't be played.", { type: "error" });
        closeModal();
      }
    });
  }, []);
  return (
    <Dialog
      open={open}
      onClose={(e) => {
        e.preventDefault();
      }}
      fullWidth={true}
      maxWidth={size}
    >
      <DialogTitle> Preview: {clipInfo.name} </DialogTitle>
      <DialogContent>
        <StyledMainBox component="main">
          <Box sx={{ display: "flex" }}>
            <StyledMainBox component="main">
              {clipUrl !== "" && (
                <video style={{ width: "100%", height: "auto" }} controls>
                  <source src={clipUrl} type="video/mp4" />
                </video>
              )}
              {/* {clipUrl && (
                <TextButton
                  href={clipUrl}
                  download
                  onClick={handleDownload}
                  label={"Download"}
                  icon={<Download />}
                  sx={{ alignSelf: "end" }}
                />
              )} */}
            </StyledMainBox>
          </Box>
        </StyledMainBox>
      </DialogContent>
      <Box height={20} />
      <DialogActions>
        <Stack direction={"row"} spacing={2}>
          <CloseButton
            onClick={(e) => {
              e.preventDefault();
              closeModal();
            }}
            label="Close"
            icon={<Close />}
          />
          <a
            href={clipUrl}
            download={clipInfo.name}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: 'none',
              display: 'inline-flex',
              alignSelf: 'end'
            }}

          >
            <ActionButton
              label={"Download"}
              icon={<Download />}
              sx={{ margin: 0 }}
            />
          </a>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default PlayClip;
